import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Form, Radio, Button, Modal, Header } from 'semantic-ui-react';
import styles from './DriverSelect.module.scss';
import moment from 'moment';

const DriverSelect = ({ policy, onDriverSelect, onCancel, confirmMessage, message, isDelete, effectiveDate }) => {
	const [selectedDriver, setSelectedDriver] = useState(null);

	const [showConfirm, setShowConfirm] = useState(false);
	const [open, setOpen] = useState(false);

	const onContinue = useCallback(() => {
		var _effectiveDate = new Date(effectiveDate).getTime();
		var _driverFutureEffectiveDate = new Date(selectedDriver.deleteFutureEffectiveDate).getTime();
		if (_driverFutureEffectiveDate !== 0 && _effectiveDate >= _driverFutureEffectiveDate) {
			setOpen(true);
			return;
		}
		if (confirmMessage) {
			setShowConfirm(true);
		} else {
			onDriverSelect(selectedDriver);
		}
	}, [confirmMessage, effectiveDate, onDriverSelect, selectedDriver]);

	const onConfirm = useCallback(() => {
		onDriverSelect(selectedDriver);
	}, [onDriverSelect, selectedDriver]);

	const drivers = useMemo(() => isDelete ? policy.drivers.filter(d => d.relationshipTypeId !== 8 && d.relationshipTypeId !== 5) : policy.drivers, [isDelete, policy.drivers])

	useEffect(() => {
		if(drivers.length === 1) {
			onDriverSelect(drivers[0]);
		}
	}, [onDriverSelect, drivers]);
	
	return (
		<div>
			<Modal open={showConfirm} onClose={() => setShowConfirm(false)} size="tiny">
				<Modal.Header>Confirm</Modal.Header>
				<Modal.Content>{confirmMessage}</Modal.Content>
				<Modal.Actions>
					<Button id="yesBtn" primary onClick={onConfirm}>Yes</Button>
					<Button id="noBtn" primary onClick={() => setShowConfirm(false)}>No</Button>
				</Modal.Actions>
			</Modal>
			<Modal open={open} onClose={() => setOpen(false)} size='tiny'>
				<Modal.Header>Warning</Modal.Header>
				<Modal.Content>{selectedDriver != null ? 'This driver is already scheduled to be deleted from the policy on ' + new Date(selectedDriver.deleteFutureEffectiveDate).toLocaleDateString() + '.' : ""}</Modal.Content>
				<Modal.Actions>
					<Button id="closeBtn" primary onClick={() => setOpen(false)}>
						Close
					</Button>
				</Modal.Actions>
			</Modal>
			<Header>{message}:</Header>
			<Form>
				{drivers.map((driver, i) => {
					return <Form.Field key={i} id={`driver${i}_radio`} control={Radio} label={`${driver.displayName} - DOB: ${moment(driver.birthDate).format('MM/DD/yyyy')}`} checked={driver === selectedDriver} onChange={() => setSelectedDriver(driver)} />;
				})}
			</Form>
			<div className={styles.buttons}>
				<Button id="continueBtn" primary disabled={!selectedDriver} onClick={onContinue}>
					Continue
				</Button>
				<Button id="cancelBtn" primary onClick={onCancel}>Cancel</Button>
			</div>
		</div>
	);
};

export default DriverSelect;
